// Placement maths for PopMenu (kept in plain JS so it can be unit-tested).
const GAP = 6;
const EDGE = 8;
// Keep clear of the app top bar (58px desktop / 48px phone) when opening up.
const TOP_EDGE = 64;

// anchor: DOMRect of the button; menu: { width, height } of the menu content.
// Opens above when it fits, otherwise on whichever side has more room, and
// never runs off the left/right edge of the viewport.
export function placeMenu(anchor, menu, vw, vh) {
  const roomAbove = anchor.top - GAP - TOP_EDGE;
  const roomBelow = vh - anchor.bottom - GAP - EDGE;
  const above = menu.height <= roomAbove || roomAbove >= roomBelow;
  const maxHeight = Math.max(120, above ? roomAbove : roomBelow);
  const h = Math.min(menu.height, maxHeight);
  const top = above ? anchor.top - GAP - h : anchor.bottom + GAP;
  const left = Math.max(EDGE, Math.min(anchor.left, vw - menu.width - EDGE));
  return { top, left, maxHeight };
}
